export const INPUT_WITH_STRING_VALIDATION_CONSTS = {
  characterLimitReachedMsg: 'Достигнут рекомендованный лимит по кол-ву символов',
  fieldIsRequiredMsg: 'Поле обязательно к заполнению'
}
